import { createStore, createStoreObject } from 'effector';

/**
 * `{ isLoading, isDone, error }` for a RecordFlow effect. Unlike
 * `createFetching`, it keeps the RecordflowError itself, so its message
 * reaches the page. Pass `reset` (an event) to clear it, e.g. workspaceChanged.
 */
export function createRequestState(effect, { reset } = {}) {
  // Kept until the next success, so a polled request that keeps failing
  // does not flicker its error banner.
  let $error = createStore(null)
    .on(effect.fail, (_, { error }) => error)
    .reset(effect.done);
  let $isDone = createStore(false)
    .on(effect.done, () => true)
    .reset(effect.fail);

  if (reset) {
    $error = $error.reset(reset);
    $isDone = $isDone.reset(reset);
  }

  return createStoreObject({
    isLoading: effect.pending,
    isDone: $isDone,
    error: $error,
  });
}
